import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { ElementBaseCopySdkModel } from './base';
import { ICopySdkModelConfig } from '../../index.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import _set from 'lodash/set';
import _unset from 'lodash/unset';
import { DataType, STPlaceholderType } from '@tencent/slide-sdk-model';
import { ICopiedShapeData, CopiedKeyType } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';

export class ShapeCopySdkModel extends ElementBaseCopySdkModel {
    private shapeModel: IShapeModel;
    public constructor(model: IShapeModel) {
        super(model);
        this.shapeModel = model;
    }

    /**
     * 复制出来的sdk数据副本
     * @param config
     */
    public getCopiedSdkModel(config: ICopySdkModelConfig = {}): ICopiedShapeData | undefined {
        return this.getCopiedSdkModelV3(config);
    }

    private getCopiedSdkModelV3(config: ICopySdkModelConfig = {}): ICopiedShapeData | undefined {
        const { isOriginal } = config;
        const allSdkData = super.getCopiedSdkModel(config);
        if (!allSdkData) return;
        if (isOriginal) {
            return allSdkData;
        }
        Object.keys(allSdkData).forEach((key) => {
            const sdkData = allSdkData[key];
            // sdk 中 isPlaceholder 是个 getter，在使用 sdk 接口拿数据的时候有可能会丢失 getter，所以使用 nvPr 判断是否是占位符
            if ((sdkData?.isPlaceholder || !!sdkData?.nvPr?.ph) && !sdkData?.isCustomPlaceholder) {
                _set(sdkData, 'nvPr.txBox', true);
            }
            if (this.isCopiedPlaceholder(sdkData)) {
                _set(sdkData, 'nvPr.txBox', false);
            } else {
                // 非 layout 里的 placeholder 不可以复制
                this.updatePlaceHolderSdkData(allSdkData as ICopiedShapeData, key as CopiedKeyType);
            }
        });

        return allSdkData;
    }

    /**
     * 更新占位符sdk数据
     */
    private updatePlaceHolderSdkData(allSdkData: ICopiedShapeData, key: CopiedKeyType): void {
        const sdkData = allSdkData[key];
        if (sdkData.type === DataType.GroupShape || !sdkData.nvPr?.ph) return;
        // 占位符的继承数据，在复制时直接移除ph属性，这样可以保证粘贴后为非占位符元素
        if (key === CopiedKeyType.INHERIT) {
            _unset(sdkData.nvPr, 'ph');
            return;
        }

        // 占位符的自身数据，应用在使用目标主题粘贴，1、使用目标主题需要算出继承样式，需要ph属性
        // 2、占位符自身数据，缺少xfrm属性，会导致无法计算粘贴后的偏移量，需要在此补充
        const { xfrm } = allSdkData[CopiedKeyType.INHERIT].spPr;
        _set(sdkData, 'spPr.xfrm', xfrm);
    }

    // 占位符是否原样复制（占位符一般复制为文本框，特殊逻辑下复制为占位符）
    // 此逻辑应该在粘贴处判断
    private isCopiedPlaceholder(cloneSdkData) {
        if (!this.shapeModel.isPlaceholder) {
            return false;
        }
        if (!(this.shapeModel.parent?.type === UIModelType.LAYOUT)) {
            return false;
        }
        if ([
            STPlaceholderType.title,
            STPlaceholderType.dt,
            STPlaceholderType.ftr,
            STPlaceholderType.sldNum,
        ].includes(cloneSdkData.nvPr.ph?.type)) {
            return false;
        }
        return true;
    }
}
